import { Block } from './Block';

// Champs communs aux deux modes d'Ensemble
interface EnsembleBase {
  id: string;
  nom: string;
  description: string;
  categorie: string;
  tags: string[];
  dateCreation: Date;
  dateModification: Date;
  auteur: string;
  version: string;
}

// Mode 'groupe' : insère plusieurs prestations en bloc (comportement historique)
export interface EnsembleGroupe extends EnsembleBase {
  mode: 'groupe';
  sections: EnsembleSection[];
}

// Mode 'ventilation' : insère UNE prestation parente + ses composants en lignes de coût
// (isVentilationCostLine=true) — unifié avec le système de ventilation benchmark.
export interface EnsembleVentilation extends EnsembleBase {
  mode: 'ventilation';
  prestation: Block;      // template de la prestation parente
  composants: Block[];    // templates des lignes de coût
}

export type Ensemble = EnsembleGroupe | EnsembleVentilation;

// Section d'un ensemble (mode groupe uniquement)
export interface EnsembleSection {
  id: string;
  nom: string;
  description?: string;
  blocs: Block[];
}

// Catégorie d'ensemble
export interface CategorieEnsemble {
  id: string;
  nom: string;
  description: string;
  couleur: string;
  icon: string;
}

// Props pour le composant de menu
export interface ChiffMenuProps {
  onSearch: (query: string) => void;
  onAddEnsemble: (ensemble: Ensemble) => void;
  onSaveSelectionAsEnsemble: (blocs: Block[], nom: string, description: string) => void;
  onSearchResultSelect: (result: any) => void;
  selectedBlocks: Block[];
  allBlocks: Block[];
  /** Ensembles créés à la volée par l'utilisateur — fusionnés avec les prédéfinis dans le dropdown. */
  userEnsembles?: Ensemble[];
  onModalOpenChange: (isOpen: boolean) => void;
  onClearSelection?: () => void;
  onConsulter?: (blocs: Block[]) => void;
}

// Props pour le dropdown des ensembles
export interface EnsembleDropdownProps {
  onSelectEnsemble: (ensemble: Ensemble) => void;
  onSaveSelectionAsEnsemble: (blocs: Block[], nom: string, description: string) => void;
  selectedBlocks: Block[];
}

// Compte le nombre total de prestations d'un ensemble (tous modes confondus)
export function getEnsemblePrestationCount(ensemble: Ensemble): number {
  if (ensemble.mode === 'groupe') {
    return ensemble.sections.reduce((total, section) => total + section.blocs.length, 0);
  }
  // ventilation : 1 prestation + N composants
  return 1 + ensemble.composants.length;
}
